import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Icon, Tooltip } from '@wmgtech/legato'

import { ConditionRender } from 'components'

import { formatDate } from 'shared/utils/formatDate'
import { findEntryOfSource, isOutdated } from 'shared/utils/charts'

import { ILastUpdateProps } from './LastUpdate.props'
import '../FactSources/FactSources.scss'

const LastUpdate: FC<ILastUpdateProps> = ({ charts, factSources }) => (
  <div className="fact-sources">
    <div className="fact-sources-source">
      <b className="fact-sources-source__title">Last Update</b>
    </div>
    {factSources.map((factSource, sourceIndex) => {
      const row = charts.find((row) => findEntryOfSource(row.entries, factSource))
      const entry = row ? findEntryOfSource(row?.entries, factSource) : undefined
      const outdatedDate = entry && isOutdated(entry?.date, factSource.period.toLowerCase())

      return (
        <div
          className={`fact-sources-source--${factSources.length} fact-sources-source fact-sources-source__date`}
          key={`factSourceDetails__${sourceIndex}`}
        >
          <span
            className={cn({
              'fact-sources-source__date--outdated': outdatedDate
            })}
          >
            {entry ? formatDate({ date: entry.received_date }) : '--'}&nbsp;
            <ConditionRender
              condition={!!outdatedDate}
              component={
                <Tooltip className="fact-sources__tooltip" message="Chart not updated" placement="top" colorType="dark">
                  <Icon name="circle-info" prefix="fas" className="fact-sources__tooltip-icon" />
                </Tooltip>
              }
            />
          </span>
        </div>
      )
    })}
  </div>
)

export default LastUpdate
